import React, {  useContext } from "react"

const  ServerStateContext = React.createContext(false);
const useServer = () => {

    return useContext(ServerStateContext);
}

// create and export the AuthProvider - this is imported to the _app.js file
// and wrapped around the whole app, providing context to the whole app, and
// is called each time this specific context is accessed (updated or retrieved)
const ServerProvider = ({ server,  children }) => {

    return (

        <ServerStateContext.Provider value={server}>
            {children}
        </ServerStateContext.Provider>

    )
};

export { ServerProvider, useServer };